import { supabase } from "@/integrations/supabase/client";

/**
 * Fire-and-forget sync of a new email signup to Beehiiv, the only ESP
 * BodyHackGuide uses. Never blocks the UI, and errors are only logged.
 *
 * 2026-05-06 audit fix: also stores the localStorage `emailSubscribed`
 * flag so popup-suppression works consistently across every signup
 * surface. Previously only 5 of 22 forms set this flag, so a user who
 * subscribed via the footer or a blog-post capture would still see the
 * cheat-sheet popup. Centralizing here makes every sync set the flag.
 *
 * 2026-09-13: this file used to be syncToAC.ts and exported a
 * `syncToActiveCampaign` alias. ActiveCampaign is gone from the project,
 * so both the filename and the alias went with it.
 */
export function syncToBeehiiv(email: string, source: string, tags?: string[]) {
  // Set the popup-suppression flag immediately. This runs synchronously
  // so even if the Beehiiv POST fails, popups stop firing for this
  // visitor. Worst case: Beehiiv didn't get the email but we treat the
  // visitor as subscribed locally — they can re-submit if needed.
  try {
    if (typeof window !== "undefined" && email) {
      localStorage.setItem("emailSubscribed", "true");
      localStorage.setItem("subscriberEmail", email);
    }
  } catch {
    // Private mode / quota — silent.
  }

  supabase.functions
    .invoke("sync-to-beehiiv", {
      body: { email, source, tags },
    })
    .then(({ error }) => {
      if (error) console.error("Beehiiv sync error:", error);
    })
    .catch((err) => console.error("Beehiiv sync failed:", err));
}
